// Definición de permisos por servicio
export const permiso = {

    // role user
    dvlpRole: 'dvlp',
    stdagAdmRole: 'stdagAdmin',
    sfacAdmRole: 'sfacAdmin',
    sfacRole: 'sfac',
    fnnzRole: 'fnnz',
    avioRole: 'avio',
    carxRole: 'carx',
    pacRole: 'paxx',
    contraRole: 'contra',
    auditorRole: 'audt',

    //group
    gDvlp: "grop.dvlp.w",
    gAdmSifac: "grop.sfacAdmin.w",
    gSifac: "grop.sfac.w",
    gFnnz: "grop.fnnz.w",
    gBoletos: "grop.avio.w",
    gAutos: "grop.carx.w",
    gPac: "grop.paxx.w",
    gContra: "grop.contra.w",
    gAudt: "grop.audt.w",

    // tables
    facturas: 'tble.facturas.r',
    accesodte: 'tble.accesodte.w',
    ordenes: 'tble.ocar.w',
    proveedores: 'tble.prov.w',
    documentos: 'tble.docu.w',
    solpago: 'tble.sopa.w',
    solcomp: 'tble.paxx.w',
    producto: 'tble.prod.w',
    item: 'tble.item.w',
    boletos: 'tble.avio.w',
    autos: 'tble.carx.w',
    user: "tble.user.w",
    role: "tble.role.w",

    // serv
    home: 'srvc.1.r',

}
